/** Shared storage identity; importing this file never starts the upload worker. */
export const ENTRY_OUTBOX_DATABASE = 'withpot-product-entry-outbox-v1';
export const ENTRY_QUEUE_DIAGNOSTIC_PATH = '/diagnostics/entry-queue';
export const isEntryQueueDiagnosticPath = (path:string) => path.replace(/\/+$/,'')===ENTRY_QUEUE_DIAGNOSTIC_PATH;
